import React, { useState } from 'react';

import { Box, Divider, Paper, Stack, Tab, Tabs, Typography } from '@mui/material';

import { CharterFlight, SeatSelectionState, Traveller } from '../charter.types';

import FlightSeatMap from './FlightSeatMap';

export type CharterSeatMapProps = {
  flights: Array<CharterFlight>;
  seatSelections: SeatSelectionState;
  travellers: Array<Traveller>;
};

export default function CharterSeatMap({
  flights,
  seatSelections,
  travellers,
}: CharterSeatMapProps): React.JSX.Element {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const activeFlight = flights[activeTab];

  return (
    <Paper variant="outlined" sx={{ pt: 1 }}>
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{
          px: 1,
          '& .MuiTabs-indicator': {
            height: 3,
          },
          '& .MuiTab-root': {
            alignItems: 'flex-start',
            textTransform: 'none',
            minHeight: 64,
          },
        }}
      >
        {flights.map((flight, index) => (
          <Tab
            key={flight.id}
            value={index}
            label={
              <Stack spacing={0.5} alignItems="flex-start">
                <Typography variant="subtitle2" fontWeight={600}>
                  {flight.depAirportCode} → {flight.arrAirportCode}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {flight.depDate} {flight.depTime}
                </Typography>
              </Stack>
            }
            sx={{
              alignItems: 'flex-start',
            }}
          />
        ))}
      </Tabs>
      <Divider />
      <Box
        sx={{
          maxHeight: { xs: '65vh', lg: '70vh' },
          overflowY: 'auto',
          px: { xs: 2, md: 3 },
          py: { xs: 2, md: 3 },
        }}
      >
        {activeFlight ? (
          <FlightSeatMap flight={activeFlight} seatSelections={seatSelections} travellers={travellers} />
        ) : null}
      </Box>
    </Paper>
  );
}
